/*
  $emit
    getsctId
 */
<template>
  <div>
    <span class="title" v-if="showTitle">学习班类型:</span>
    <el-select v-model="value" placeholder="请选择学习班类型" @change="getsctId">
      <el-option v-for="item in datas" :key="item.id" :label="item.title" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { optionsApi } from "@/api/module/studyclasstype/studyclasstype";

export default {
  name: "StudyclassTidSelect",
  
  mixins: [BaseVue],
  
  props: {
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  
  data() {
    return {
      StudyClassTypeId: "",
      datas: [],
      value: "",
      current_page: 1,
      page_size: 10,
      total: 0,
      searchword: "",
      status: 0,
      serverUrl: "/api/manager/studyclasstype"
    };
  },
  
  methods: {
    getsctId(e) {
      console.log(144, e);
      for (let i = 0; i < this.datas.length; i++) {
        let item = this.datas[i];
        if (item.id == e) {
          let data = {
            studyClassId: e,
            studyClassVal: item.title
          };
          this.$emit("getsctId", data);
          return;
        }
      }
    },
    
    initDate(e) {
      this.StudyClassTypeId = e;
    }
  },
  
  created() {
    let data = {
      test: 1
    };

    optionsApi(data)
      .then(response => {
        this.datas = response;
      })
      .catch(error => {
        console.log(error);
      });
  },
  
  watch: {
    StudyClassTypeId: {
      handler(newVal) {
        this.value = newVal;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  margin-right: 50px;
}
</style>